<template>
    <div>
        <div style="display: inline-block">
            <label for="group" class="name-label">Skupina: </label>
            <input class="name-input" id="group" type="text" v-model="group"/>
        </div><br>
        <span v-for="option in options" :key="option.foodOptionId">
            <span class="mdl-chip mdl-shadow--2dp" v-on:click="select(option)">
                <span class="mdl-chip__text">{{ option.name }}</span>
            </span>&nbsp;
        </span>
        <div>
            <label for="option_name" class="name-label">Nový:</label>
            <input class="name-input" id="option_name" type="text" v-model="name"/>
        </div>

        <button class="mdl-button add-button" v-on:click="add()">Přidat</button>
    </div>
</template>

<script>
    import axios from "axios";
    import config from "../config"

    export default {
        name: "FoodOptionSelect",
        data: function () {
            return {
                options: Array,
                name: "",
                group: 0
            }
        },
        methods: {
            load: function () {
                axios
                    .get(config.host + "/v1/menu/optionType")
                    .then(response => (this.options = response.data))
            },
            add: function () {
                if (this.name != null && this.name !== "") {
                    axios
                        .post(config.host + "/v1/menu/optionType/" + this.name)
                        // eslint-disable-next-line no-unused-vars
                        .then(response => this.load())
                }
                this.name = "";
            },
            select: function (option) {
                let group = this.group;
                this.$emit('option-selected', option, group);
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
    .name-input {
        width: 7em;
        float: left;
        margin-right: 1em;
        margin-top: 2.4em
    }

    .name-label {
        float: left;
        margin-right: 1em;
        margin-top: 2em;
    }

    .add-button {
        float: left;
        margin-top: 1.5em;
    }
</style>